import { useContext, useEffect } from "react";
import AppContext from "src/app/AppContext";
import { DEFAULT_VISITOR_CONTEXT } from "src/trackers/viewerContext";

// A landing-only event name: on the shared GTM container "gaEvent" would log as "pdf portal".
export function usePageView(): void {
  const { visitorContext } = useContext(AppContext);

  useEffect(() => {
    const visitor = visitorContext ?? DEFAULT_VISITOR_CONTEXT;
    const w = window as unknown as Window & {
      dataLayer?: Record<string, unknown>[];
    };
    w.dataLayer = w.dataLayer || [];
    w.dataLayer.push({
      event: "page_view",
      event_details: {
        pageName: document.title,
        visitorCategory: visitor.visitorCategory,
        visitorId: visitor.visitorId,
        svc: visitor.svc,
      },
    });
  }, []);
}
